import { axiosInstance } from '~/services';

import type { TypeGetOwnerSupplierListCodesResponse } from '~/types/vender.types';

/**
 * [화주사정보관리 > 공급사관리] 공급사목록 필터 조회
 */
const useGetOwnerSupplierListCodes = () => {
  const endPoint = '/api-owner/owner-supplier/list/codes';

  const getOwnerSupplierListCodes = async () => {
    return axiosInstance
      .get<TypeGetOwnerSupplierListCodesResponse>(endPoint)
      .then(({ data }) => {
        return data.data;
      })
      .catch((error) => {
        throw error;
      });
  };

  return { getOwnerSupplierListCodes };
};

export default useGetOwnerSupplierListCodes;
